import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageGlowContainer from '../components/PageLayout';
import ProfessionalPage from '../components/ProfessionalPage';
import avatarImage from '../assets/IMG_9833_inPixio.png';
import { aboutProfile, aboutIntro, aboutWorkHistory } from '../content/aboutContent';

const About = ({ theme }) => {
  const navigate = useNavigate();
  const [selectedIdx, setSelectedIdx] = useState(0);

  if (theme === 'professional') {
    return (
      <ProfessionalPage title="About Me">
        <p><strong>{aboutProfile.name}</strong></p>
        <p>{aboutProfile.role}</p>
        <p>{aboutProfile.location}</p>
        <p>{aboutIntro}</p>
      </ProfessionalPage>
    );
  }

  return (
    <>
      <div className="ddr-grid"></div>
      <PageGlowContainer title="About Me" glowColor="#FFEB3B" onEsc={() => navigate('/') }>
        {/* Profile header */}
        <section className="about-profile">
          <img src={avatarImage} alt="Quinton Tracey avatar" className="about-avatar" />
          <div className="about-header-text">
            <h2 className="about-name">{aboutProfile.name}</h2>
            <p className="about-role">{aboutProfile.role}</p>
            <p className="about-tagline">{aboutProfile.location}</p>
            <div className="about-actions">
              <a className="btn-linkedin" href={aboutProfile.links.linkedIn} target="_blank" rel="noopener noreferrer">LinkedIn</a>
              <a className="btn-github" href={aboutProfile.links.github} target="_blank" rel="noopener noreferrer">GitHub</a>
            </div>
          </div>
        </section>

        {/* Intro */}
        <p className="about-intro">
          {aboutIntro}
        </p>

        {/* Experience quick switcher */}
        <section className="about-experience">
          <div className="about-tabs">
            {aboutWorkHistory.map((job, idx) => (
              <button
                key={job.company + job.title}
                className={`about-tab ${idx === selectedIdx ? 'active' : ''}`}
                onClick={() => setSelectedIdx(idx)}
              >
                {job.title} <span className="muted">@ {job.company}</span>
              </button>
            ))}
          </div>
          <div className="about-tabpanel">
            <div className="about-desc">{aboutWorkHistory[selectedIdx].description}</div>
            <div className="about-date">{aboutWorkHistory[selectedIdx].date}</div>
          </div>
        </section>
      </PageGlowContainer>
    </>
  );
};

export default About; 